import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import Icon from 'dpl/common/components/Icon';
import Badge from 'dpl/common/design_system/Badge';
import {
  BADGE_VARIANTS,
  COLOR_OPTIONS
} from 'dpl/common/design_system/utils/constants';
import SmartLink from 'dpl/components/SmartLink';

function getComponent({ url, onClick }) {
  if (url) return SmartLink;
  if (onClick) return 'button';
  return 'span';
}

export default function NavMenuOptions({ className, options }) {
  return (
    <ul className={classnames('NavMenuOptions', className)}>
      {options.map(
        ({
          className: optionClassName,
          badge,
          iconName,
          label,
          url,
          onClick
        }) => {
          const Component = getComponent({ url, onClick });

          return (
            <li key={label}>
              <Component
                className={classnames(
                  'flex items-center gap-12 fw-medium lh-title pv3',
                  optionClassName ?? 'secondary'
                )}
                to={url}
                onClick={onClick}
              >
                <Icon
                  className="tertiary"
                  name={iconName}
                  height="24px"
                  width="24px"
                />
                <span className="font-16">{label}</span>
                {badge && (
                  <Badge
                    className="nl1"
                    size="xsmall"
                    color={badge.color}
                    variant={badge.variant}
                  >
                    <span
                      className="db tc"
                      style={{ minWidth: '1em', margin: '-2px 0px' }}
                    >
                      {badge.text}
                    </span>
                  </Badge>
                )}
              </Component>
            </li>
          );
        }
      )}
    </ul>
  );
}

NavMenuOptions.propTypes = {
  className: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      iconName: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      url: PropTypes.string,
      badge: PropTypes.shape({
        variant: PropTypes.oneOf(Object.keys(BADGE_VARIANTS)),
        color: PropTypes.oneOf(COLOR_OPTIONS),
        text: PropTypes.string.isRequired
      }),
      onClick: PropTypes.func
    })
  ).isRequired
};

NavMenuOptions.defaultProps = {
  className: null
};
